import { Component, OnInit } from '@angular/core';
import { FantasyHistory, FantasyHistoryQuery } from '@fgb/core';
import { map, Observable } from 'rxjs';
@Component({
  selector: 'fgb-fantasy-game-results',
  templateUrl: './fantasy-game-results.component.html',
  styleUrl: './fantasy-game-results.component.scss',
})
export class FantasyGameResultsComponent implements OnInit {
  fantasyHistory$: Observable<FantasyHistory[]>;
  pendingPeriod: number = 0;

  constructor(private fantasyHistoryQuery: FantasyHistoryQuery) {}

  ngOnInit() {
    this.fantasyHistory$ = this.fantasyHistoryQuery.selectAllHistory().pipe(map((x) => (x = x.slice(0, 8))));
  }
}
